import { render, staticRenderFns } from "./LinkingOptionsModal.vue?vue&type=template&id=5b5e86e4&scoped=true&"
import script from "./LinkingOptionsModal.vue?vue&type=script&lang=js&"
export * from "./LinkingOptionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5e86e4",
  null
  
)

export default component.exports